<template>
    <div class="justify-content-center">
        <div class="col-10 mx-auto py-5 px-0">
            <table class="mx-auto" style="width: 70%;">
                <thead>
                    <tr>
                        <th class="px-2 text-right" style="width: 10%;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="rgba(255, 255, 255, .87)" class="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                            </svg>
                        </th>
                        <th class="px-2" style="width: 45%;">
                            <input type="text"
                                style="font-size: 11px; width: 100%; border: none; border-radius: 5px; background-color: rgb(30, 30, 30); padding: 5px; color: rgba(255, 255, 255, .6);"
                                placeholder="Rechercher le secteur"
                                v-model="filtersector"
                                @change="onFilterSectorChange()">
                        </th>
                        <th class="px-2" style="width: 45%;">
                            <input type="text"
                                style="font-size: 11px; width: 100%; border: none; border-radius: 5px; background-color: rgb(30, 30, 30); padding: 5px; color: rgba(255, 255, 255, .6);"
                                placeholder="Rechercher le nom d'un fond"
                                v-model="filtername"
                                @change="onFilterNameChange()">
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-5" style="align-self: center;">
                <p class="fts-20 light-white-03" style="font-weight: 900;">Vos positions en portefeuilles</p>
            </div>
            <div class="col-md-5">
                <p class="fts-20 light-white-03" style="font-weight: 900;">Les fonds responsables (ESG) avec le même risque</p>
            </div>
        </div>
        <div class="row justify-content-center mb-5" v-for="(comparison, index) in customs" :key="comparison.name+'comparison'+index">
            <input type="hidden" :id="comparison.isin" v-model="comparison.has_traded">
            <div class="col-md-5 element-x-ray m-2" style="position: relative; border: 1px solid rgba(255, 255, 255, .12);" v-if="comparison.has_traded == 0">
                <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 90%;">
                    <p class="fts-18 light-blue-01" style="font-weight: 900;">{{ comparison.name }}</p>
                    <p class="light-white-03">Secteur : {{ comparison.sector }}</p>
                    <p class="light-white-03">Score Esg : {{ comparison.esg_score }}</p>
                    <p class="light-white-03">ISIN : {{ comparison.isin }}</p>
                    <p class="light-white-03">Frais de gestion : {{ Math.round(comparison.fees*100)/100 }}</p>
                    <p class="fts-18 font-weight-bold light-white-03">Vous possédez actuellement <span class="light-blue-01">{{ Math.round(comparison.amount,0) }} €</span> (<span class="light-blue-01">{{ Math.round(comparison.number_shares,0) }}</span> parts)</p>
                </div>
            </div>
            <div id="esg_alt" class="col-md-5 pl-0" style="overflow-x: scroll; overflow-y: hidden;">
                <table style="width: max-content;">
                    <tbody>
                        <tr>
                            <td v-for="(alternative_ESG, index1) in comparison.alternatives_ESG" :key="alternative_ESG.name+'alternative_ESG'+index1">
                                <div class="element-x-ray mb-3 mr-2" style="width: 500px; height: 270px; border: 1px solid rgba(255, 255, 255, .12);">
                                    <div class="py-2" style="font-weight: 900; color: #03dac5;">
                                        {{ alternative_ESG.name }}
                                    </div>
                                    <div class="py-2 light-white-03">
                                        ISIN : {{ alternative_ESG.ISIN_code }}
                                    </div>
                                    <div class="py-2 light-white-03">
                                        Frais de gestions : {{ Math.round(alternative_ESG.fees*100,2)/100 }} %
                                    </div>
                                    <div class="py-2">
                                        <div v-if="access === true" style="display: contents;" id="random">
                                            <button class="btn-alt-3"  v-b-modal="modalId(alternative_ESG.ISIN_code+' '+comparison.isin)">
                                                Opter pour ce fond
                                            </button>
                                            <b-modal
                                                title="Comment effectuer le passage d'ordre"
                                                class="modal fade alt-list" :id="'modal' + alternative_ESG.ISIN_code+' '+comparison.isin"
                                                tabindex="-1"
                                                role="dialog"
                                                aria-labelledby="alternatives"
                                                aria-hidden="true"
                                                :header-bg-variant="headerBgVariant"
                                                :header-text-variant="headerTextVariant"
                                                :body-bg-variant="bodyBgVariant"
                                                :body-text-variant="bodyTextVariant"
                                                :footer-bg-variant="footerBgVariant"
                                                :footer-text-variant="footerTextVariant"
                                                ok-only
                                                >
                                                <div>
                                                    <p class="py-2 light-white-03 text-center" id='vente'>Vendez <span class="font-weight-bold" style="color: rgb(99, 91, 255);">{{ Math.round(comparison.amount,0) }} €</span> de <span class="font-weight-bold" style="color: rgb(99, 91, 255);">{{ comparison.name }} - {{ comparison.isin }}</span></p>
                                                    <p class="py-2 light-white-03 text-center" id='achat'>Achetez <span class="font-weight-bold" style="color: #03dac5;">{{ Math.round(comparison.amount,0) }} €</span> de <span class="font-weight-bold" style="color: #03dac5;">{{ alternative_ESG.name }} - {{ alternative_ESG.ISIN_code }}</span></p>
                                                    <p style='display: none;' id='contract_id'>{{ comparison.contract_id }}</p>
                                                    <p style='display: none;' id="platform_id">{{ comparison.platform_id }}</p>
                                                    <p class="py-2 light-white-03 text-center">⚠️ Si vous n'êtes pas actuellement connecté à <span style="text-transform: capitalize; font-weight: bold; color: #635bff;">{{ comparison.platform }}</span>, veuillez d'abord vous identifier <a :href="comparison.platform_link" target="_blank" rel="noopener noreferrer" style="font-weight: bold; color: #635bff;">ici</a>.</p>
                                                    <p class="py-2 light-white-03 text-center font-weight-bold fts-22">🧙🏿‍♂️ L'assistant myfo</p>
                                                    <p class="py-2 light-white-03 text-center">Cliquez sur l'extension myfo et passez l'ordre automatiquement via <span style="text-transform: capitalize; font-weight: bold; color: #635bff;">{{ comparison.platform }}</span>.</p>
                                                    <div class="text-center">
                                                        <img src="/ressources/SCAN/RTO.png" style="max-width: 400px;">
                                                    </div>
                                                    <div id="button_extension">
                                                        <p class="py-2 light-white-03 text-center">Il semblerait que vous n'ayez pas encore installé l'assistant myfo, <a :href="'/app/home/explain/extension'" target="_blank" style="color: rgb(99, 91, 255);">veuillez cliquer ici.</a></p>
                                                    </div>
                                                    <p class="py-2 light-white-03 text-center">Les champs se préremplissent et vous n'avez plus qu'à valider la vente de <span style="text-transform: capitalize; font-weight: bold; color: #635bff;">{{ comparison.name }}</span> et l'achat de <span style="text-transform: capitalize; font-weight: bold; color: #03dac5;">{{ alternative_ESG.name }}</span>.</p>
                                                </div>
                                            </b-modal>
                                        </div>
                                        <div v-if="access === false" style="display: contents;" id="random">
                                            <p class="light-white-02 fts-14" style="display: inline-block; padding-right: 5px;">Pour opter pour ce fond :</p>
                                            <button class="btn-transparncy" style="margin: 0px!important; font-size: 14px!important; padding: 10px!important; display: inline-block;" v-b-modal="modalId(alternative_ESG.ISIN_code)">
                                                Passer premium
                                            </button>
                                            <b-modal
                                                :id="'modal' + alternative_ESG.ISIN_code"
                                                title="Débloquez l'étendue des fonctionnalités"
                                                ok-only
                                                tabindex="-1"
                                                role="dialog"
                                                aria-labelledby="alternatives"
                                                aria-hidden="true"
                                                :header-bg-variant="headerBgVariant"
                                                :header-text-variant="headerTextVariant"
                                                :body-bg-variant="bodyBgVariant"
                                                :body-text-variant="bodyTextVariant"
                                                :footer-bg-variant="footerBgVariant"
                                                :footer-text-variant="footerTextVariant"
                                            >
                                                <p class="py-2 light-white-03 text-center">Pour accéder aux positions qui vous feraient économiser le plus, veuillez passer à la version premium.</p>
                                                <div class="text-center">
                                                    <button class="btn-transparncy m-4"><a :href="'/app/home/payment/portal'">Upgrader</a></button>
                                                </div>
                                            </b-modal>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td v-for="(alternative_ESG_broad, index3) in comparison.alternatives_ESG_broad" :key="alternative_ESG_broad+'alternative_ESG_broad'+index3">
                                <div class="element-x-ray mb-3 mr-2" style="width: 500px; height: 270px; position: relative; border: 1px solid rgba(255, 255, 255, .12);">
                                    <div class="py-2" style="font-weight: 900; color: #03dac5;">
                                        {{ alternative_ESG_broad.name }}
                                        <span style="position: absolute; top: 1.5%; right: 1.5%; background-color: #121212; padding: 5px; border-radius: 5px; color: #03dac5; font-weight:bold; font-size: 10px;">Secteur différent</span>
                                    </div>
                                    <div class="py-2 light-white-03">
                                        ISIN : {{ alternative_ESG_broad.ISIN_code }}
                                    </div>
                                    <div class="py-2 light-white-03">
                                        Secteur : {{ alternative_ESG_broad.sector.name_french }}
                                    </div>
                                    <div class="py-2 light-white-03">
                                        Score cliamt : {{ alternative_ESG_broad.esg_score }}
                                    </div>
                                    <div class="py-2 light-white-03">
                                        Les frais de gestion : {{ Math.round(alternative_ESG_broad.fees*100,2)/100 }} %
                                    </div>
                                    <div class="py-2">
                                        <div v-if="comparison.platform_contract.extension === 1">
                                            <button class="btn-alt-3"  v-b-modal="modalId(alternative_ESG_broad.ISIN_code)">
                                                Opter pour cette position
                                            </button>
                                            <b-modal
                                                title="Comment effectuer le passage d'ordre"
                                                class="modal fade alt-list" :id="'modal' + alternative_ESG_broad.ISIN_code"
                                                tabindex="-1"
                                                role="dialog"
                                                aria-labelledby="alternatives"
                                                aria-hidden="true"
                                                :header-bg-variant="headerBgVariant"
                                                :header-text-variant="headerTextVariant"
                                                :body-bg-variant="bodyBgVariant"
                                                :body-text-variant="bodyTextVariant"
                                                :footer-bg-variant="footerBgVariant"
                                                :footer-text-variant="footerTextVariant"
                                                ok-only
                                                >
                                                <div>
                                                    <p class="py-2 light-white-03 text-center" id='vente'>Vendez <span class="font-weight-bold" style="color: rgb(99, 91, 255);">{{ Math.round(comparison.amount,0) }} €</span> de <span class="font-weight-bold" style="color: rgb(99, 91, 255);">{{ comparison.name }} - {{ comparison.isin }}</span></p>
                                                    <p class="py-2 light-white-03 text-center" id='achat'>Achetez <span class="font-weight-bold" style="color: #03dac5;">{{ Math.round(comparison.amount,0) }} €</span> de <span class="font-weight-bold" style="color: #03dac5;">{{ alternative_ESG_broad.name }} - {{ alternative_ESG_broad.ISIN_code }}</span></p>
                                                    <p style='display: none;' id='contract_id'>{{ comparison.contract_id }}</p>
                                                    <p style='display: none;' id="platform_id">{{ comparison.platform_id }}</p>
                                                    <p class="py-2 light-white-03 text-center">⚠️ Si vous n'êtes pas actuellement connecté(e) à <span style="text-transform: capitalize; font-weight: bold; color: #635bff;">{{ comparison.platform }}</span>, veuillez d'abord vous identifier <a :href="comparison.platform_link" target="_blank" rel="noopener noreferrer" style="font-weight: bold; color: #635bff;">ici</a>.</p>
                                                    <p class="py-2 light-white-03 text-center font-weight-bold fts-22">🧙🏿‍♂️ L'assistant myfo</p>
                                                    <p class="py-2 light-white-03 text-center">Cliquez sur l'extension myfo et effectuez le passage d'ordre automatiquement via <span style="text-transform: capitalize; font-weight: bold; color: #635bff;">{{ comparison.platform }}</span>.</p>
                                                    <div class="text-center">
                                                        <img src="/ressources/SCAN/RTO.png" style="max-width: 400px;">
                                                    </div>
                                                    <div id="button_extension">
                                                        <p class="py-2 light-white-03 text-center">Il semblerait que vous n'ayez pas encore installé l'assistant myfo, <a :href="'/app/home/explain/extension'" target="_blank" style="color: rgb(99, 91, 255);">veuillez cliquer ici.</a></p>
                                                    </div>
                                                    <p class="py-2 light-white-03 text-center">Les champs se préremplissent et vous n'avez plus qu'à valider la vente de <span style="text-transform: capitalize; font-weight: bold; color: #635bff;">{{ comparison.name }}</span> et l'achat de <span style="text-transform: capitalize; font-weight: bold; color: #03dac5;">{{ alternative_ESG_broad.name }}</span>.</p>
                                                </div>
                                            </b-modal>
                                        </div>
                                        <div v-else>
                                            <button class="btn-alt-3"  v-b-modal="modalId(alternative_ESG_broad.ISIN_code)">
                                                Opter pour cette position
                                            </button>
                                            <b-modal
                                                title="Comment effectuer le passage d'ordre"
                                                class="modal fade alt-list" :id="'modal' + alternative_ESG_broad.ISIN_code"
                                                tabindex="-1"
                                                role="dialog"
                                                aria-labelledby="alternatives"
                                                aria-hidden="true"
                                                :header-bg-variant="headerBgVariant"
                                                :header-text-variant="headerTextVariant"
                                                :body-bg-variant="bodyBgVariant"
                                                :body-text-variant="bodyTextVariant"
                                                :footer-bg-variant="footerBgVariant"
                                                :footer-text-variant="footerTextVariant"
                                                ok-only
                                                >
                                                <div>
                                                    <p class="py-3 light-white-03 text-center font-weight-bold fts-22">Il semblerait que votre plateforme ne soit pas encore gérée par l'assistant myfo.</p>
                                                    <p class="py-3 light-white-03 text-center font-weight-bold fts-22">Si vous souhaitez nous aider à la rajouter, <a style="color: rgb(99, 91, 255);" href="mailto:contact@myfo.fr?subject=Ajout%20de%20plateforme%20-%20Assistant%20myfo">envoyez-nous votre demande</a> 📧 !</p>
                                                </div>
                                            </b-modal>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'comparisons',
            'accessgranted',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                filtername:"",
                access:"",
                filtersector:"",
                show: false,
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        mounted() {
            this.comparisons.forEach(comparison =>
            {
                this.customs.push(comparison)
            });
            this.access = this.accessgranted;
        },


        methods: {
            onFilterNameChange(){
                this.customs=[];
                this.comparisons.forEach(comparison =>
                {
                    if (comparison.name.toLowerCase().includes(this.filtername.toLowerCase()))
                    {
                        this.customs.push(comparison);
                    }
                });

            },
            onFilterSectorChange(){
                this.customs=[];
                this.comparisons.forEach(comparison =>
                {
                    if (comparison.sector.toLowerCase().includes(this.filtersector.toLowerCase()))
                    {
                        this.customs.push(comparison);
                    }
                });

            },
            sectorSortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.sector < b.sector)
                    {
                        return -1;
                    }
                    else if (a.sector > b.sector)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            modalId(i) {
            return 'modal' + i;
            },
    }
}

</script>